import React, { useContext, useEffect, useState } from 'react'
import DatePickerC from '../../../formFields/DatePicker'
import { useTranslation } from 'react-i18next'
import { handleDate } from '../../../../utils'
import { DomainContext } from '../../../../context/DomainContext'

const DatePickerSearch = ({ Header, isMulti, className, accessor, probName }) => {

    const [dates, setDates] = useState()

    const { setCustomSearchData, customSearchData, clearField } = useContext(DomainContext)



    const { t } = useTranslation()

    useEffect(() => {
        let searchObjectValues = customSearchData;

        if (!isMulti) {
            searchObjectValues[probName || accessor] = handleDate(dates)
        } else {
            searchObjectValues[`from${probName || accessor}`] = dates?.[accessor]?.value ? handleDate(dates?.[accessor]?.value?.from) : ""
            searchObjectValues[`to${probName || accessor}`] = dates?.[accessor]?.value ? handleDate(dates?.[accessor]?.value?.to) : ""
        }

        setCustomSearchData((prev) => ({...prev, ...searchObjectValues}))

    }, [dates])

    useEffect(() => {
        setDates(null)
    }, [clearField])

    const handleFormValues = (name, value) => {
        setDates((prev) => ({ ...prev, [name]: value }))
    }

    return (
        <>
            <DatePickerC isSingle={!isMulti} isRequired={false} className={className} name={probName || accessor} formHandler={{ formValues: { Date: { value: dates?.[accessor]?.value } }, handleFormValues: handleFormValues }} placeholder={t(Header) || ''} />
        </>
    )
}

export default DatePickerSearch